import Vue from 'vue'
import firebase from '../firebase'


export default {
  namespaced: true,
  state: {
    ready: false,
    loading: true,
    logged: false,
    user: null,
    profile: null,
    error: null,
    showSession: false,
    isAdmin: false
  },
  actions: {
    initialize ({ commit, state, dispatch }) {
      console.log('auth initialize')
      // return new Promise((resolve, reject) => {
        firebase.auth.onAuthStateChanged(async (user) => {
          console.log('user: ', user)
          if (user && user.uid) {
            const profile = await (await firebase.firestore.collection('profiles').doc(user.uid).get()).data()
            var isAdmin = await (await firebase.firestore.collection('admins').doc(user.uid).get()).data()
            console.log('profile: ', profile)
            if (profile) {
              commit('SET_PROFILE', profile)
            }
            isAdmin = isAdmin ? true : false
            commit('SET_IS_ADMIN', isAdmin)
      
            commit('SUCCESS_LOGIN', { ...user })
            // resolve()
          } else {
            commit('LOGOUT')
          }
          if (!state.ready) {
            commit('READY')
          }
        })
      // })
    },
    async setProfile ({commit, state}, profile) {
      return new Promise(async (resolve) => {
        if (state.user && state.user.uid) {
          if (profile.ref && profile.base64Image) {
            const snapshot = await profile.ref.putString(profile.base64Image.split(',')[1], 'base64')
            profile.image = await snapshot.ref.getDownloadURL()
          }
          // Copia saneada: los campos de UI del editor (password, email, newemail)
          // nunca deben persistirse en Firestore
          const data = {...profile}
          delete data.id
          delete data.ref
          delete data.base64Image
          delete data.password
          delete data.email
          delete data.newemail
          await firebase.firestore.collection('profiles').doc(state.user.uid).set(data)
          commit('SET_PROFILE', data)
          resolve(true)
        }
        resolve(false)
      });
    },
    async logout ({commit, dispatch}) {
      try {
        commit('LOADING', true)
        await firebase.auth.signOut()
        dispatch('profiles/cleanup', null, { root: true })
      } catch (err) {
        commit('ERROR', err)
      } finally {
        commit('LOADING', false)
      }
    },
    showSession ({commit}, show) {
      commit('SHOW_SESSION', show)
    }
  },
  mutations: {
    READY (state) {
      Vue.set(state, 'ready', true)
    },
    LOADING (state, loading) {
      Vue.set(state, 'loading', loading)
    },
    ERROR (state, error) {
      Vue.set(state, 'error', error)
    },
    SUCCESS_LOGIN (state, user) {
      Vue.set(state, 'user', user)
      Vue.set(state, 'logged', true)
      Vue.set(state, 'loading', false)
    },
    LOGOUT (state) {
      Vue.set(state, 'user', null)
      Vue.set(state, 'profile', null)
      Vue.set(state, 'logged', false)
      Vue.set(state, 'loading', false)
      Vue.set(state, 'isAdmin', false)
    },
    SHOW_SESSION (state, show) {
      Vue.set(state, 'showSession', show)
    },
    SET_PROFILE (state, profile) {
      Vue.set(state, 'profile', profile)
    },
    SET_IS_ADMIN (state, isAdmin) {
      Vue.set(state, 'isAdmin', isAdmin)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js